<template>
    <el-select
        v-model="modelValue"
        :value-key="valueKey"
        clearable
        :value="value"
        multiple
    >
        <el-option
            v-for="item in options"
            :key="item[valueField]"
            :label="item[labelField]"
            :value="item[valueField]"
        >
        </el-option>
    </el-select>
</template>

<script>
export default {
    props: {
        value: {
            type: [Number, String, Array, Object],
            default: "",
        },
        valueKey: {
            type: String,
            default: "value",
        },
        options: {
            type: Array,
            default: () => [],
        },
        labelField: {
            type: String,
            default: "label",
        },
        valueField: {
            type: String,
            default: "value",
        },
    },

    computed: {
        modelValue: {
            get({ value, $attrs }) {
                if ($attrs.multiple && !Array.isArray(value)) return [];
                return value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
    },
};
</script>